import { c as _c } from "react/compiler-runtime";
import { UseDebounceType } from "@website/hooks/debounce/debounce.types";
import isEqual from "lodash-es/isEqual";
import { useEffect, useRef, useState } from "react";
export const useDebounce: UseDebounceType = (value, timeout) => {
  const $ = _c(5);
  const timer = useRef(null);
  const [debouncedValue, setDebouncedValue] = useState(value);
  let t0;
  if ($[0] !== timeout || $[1] !== value) {
    t0 = () => {
      if (timer.current) {
        clearTimeout(timer.current);
      }
      timer.current = setTimeout(() => setDebouncedValue(state => isEqual(value, state) ? state : value), timeout ?? 500);
      return () => {
        if (timer.current) {
          clearTimeout(timer.current);
          timer.current = null;
        }
      };
    };
    $[0] = timeout;
    $[1] = value;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  let t1;
  if ($[3] !== value) {
    t1 = [value];
    $[3] = value;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  useEffect(t0, t1);
  return debouncedValue;
};